exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir=ltr] ._1BxOwL1HuG1ooVN3vdFSuU{margin:8px 0 8px 26px}html[dir=rtl] ._1BxOwL1HuG1ooVN3vdFSuU{margin:8px 26px 8px 0}html[dir] .HaO3Ai7EE_kKyb8uJcR6s{margin:4px 0 16px}html[dir=ltr] ._196Cv0ipsyYIixQvTXjPIg{padding-left:0}html[dir=rtl] ._196Cv0ipsyYIixQvTXjPIg{padding-right:0}", ""]);

// exports
exports.locals = {
	"formContainer": "_1BxOwL1HuG1ooVN3vdFSuU",
	"emailInput": "HaO3Ai7EE_kKyb8uJcR6s",
	"label": "_196Cv0ipsyYIixQvTXjPIg"
};